import { useContext } from "react"
import PasswordField from "../../../../../components/inputs/PasswordField"
import { UserManagementContext } from "../UserManagementScreen"

export const UserDetailsSection = () => {
    const { state, setState } = useContext(UserManagementContext)

    const _handleSetValue = (k, v) => {
        setState({ ...state, user: { ...state.user, [k]: v } })
    }

    const handleValidation = (value, type) => {
        switch (type) {
            case 'ID Number':
                if (!/^\d{12,}$/.test(value)) {
                    return "Invalid ID Number";
                }
                break
            default:
                return null
        }
        return null;
    }

    return <div className='text-center'>
        <h3>User Details</h3>
        <div className='row'>
            <div className="col-sm-2 col-md-2">
                <div className="validation-container">
                    <label>Title</label>
                    <select defaultValue={state.user?.title} onChange={(e) => _handleSetValue('title', e.target.value)} className="form-control">
                        <option selected={state.user && state.user?.title === "Mr" ? '"selected"' : ''} value="Mr">Mr</option>
                        <option selected={state.user && state.user?.title === "Mrs" ? '"selected"' : ''} value="Mrs">Mrs</option>
                        <option selected={state.user && state.user?.title === "Miss" ? '"selected"' : ''} value="Miss">Miss</option>
                        <option selected={state.user && state.user?.title === "Ms" ? '"selected"' : ''} value="Ms">Ms</option>
                        <option selected={state.user && state.user?.title === "Dr" ? '"selected"' : ''} value="Dr">Dr</option>
                        <option selected={state.user && state.user?.title === "Prof" ? '"selected"' : ''} value="Prof">Prof</option>
                        <option selected={state.user && state.user?.title === "Other" ? '"selected"' : ''} value="Other">Other</option>
                    </select>
                    <div className="validation-details"></div>
                </div>
            </div>
            <div className='col-5'>
                <label>First Name</label>
                <input
                    onChange={(e) => _handleSetValue('firstName', e.target.value)}
                    className='form-control' placeholder='First Name' defaultValue={state.user ? state.user.firstName : ''} />
            </div>
            <div className='col-5'>
                <label>Last Names</label>
                <input
                    onChange={(e) => _handleSetValue('lastName', e.target.value)}
                    className='form-control' placeholder='Last Names' defaultValue={state.user ? state.user.lastName : ''} />
            </div>


            <div className="col-6">
                <div className="validation-container">
                    <label>ID/Passport Number</label>
                    <input defaultValue={state.user?.idNumber} onChange={(e) => _handleSetValue('idNumber', e.target.value)} className="wizard-input form-control" placeholder="ID Number" />
                    <div className="validation-details">{handleValidation(state.user?.idNumber, 'ID Number')}</div>
                </div>
            </div>


            <div className="col-6">
                <div className="validation-container">
                    <label>Password</label>
                    <PasswordField defaultValue={state.user?.password} onChange={(e) => _handleSetValue('password', e.target.value)} />
                    <div className="validation-details"></div>
                </div>
            </div>
            <div className="col-6">
                <div className="validation-container">
                    <label>Email Address</label>
                    <input defaultValue={state.user?.emailAddress} onChange={(e) => _handleSetValue('emailAddress', e.target.value)} className="wizard-input form-control" placeholder="Email Address" />
                    <div className="validation-details"></div>
                </div>
            </div>
            <div className="col-6">
                <div className="validation-container">
                    <label>Mobile Number</label>
                    <input defaultValue={state.user?.mobileNumber} onChange={(e) => _handleSetValue('mobileNumber', e.target.value)} className="wizard-input form-control" placeholder="Mobile Number" />
                    <div className="validation-details"></div>
                </div>
            </div>

        </div>
    </div>
}